import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import { tableRowCSSVars as cssVars } from './dynamic-table';
const rowStyles = css({
  backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
  '&:focus': {
    outline: `2px solid ${`var(--ds-border-focused, ${`var(${cssVars.CSS_VAR_HOVER_BACKGROUND})`})`}`,
    outlineOffset: `-2px`
  }
});
const rowBackgroundStyles = css({
  '&:hover': {
    backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${cssVars.CSS_VAR_HOVER_BACKGROUND})`})`
  }
});
const rowHighlightedBackgroundStyles = css({
  backgroundColor: `var(--ds-background-selected, ${`var(${cssVars.CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
  '&:hover': {
    backgroundColor: `var(--ds-background-selected-hovered, ${`var(${cssVars.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
  }
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const TableBodyRow = /*#__PURE__*/forwardRef(({
  isHighlighted,
  children,
  style,
  testId,
  ...rest
}, ref) => {
  return jsx("tr", _extends({
    style: style,
    css: [rowStyles, isHighlighted ? rowHighlightedBackgroundStyles : rowBackgroundStyles]
  }, rest, {
    ref: ref,
    "data-testid": testId
  }), children);
});